module.exports = __webpack_public_path__ + "static/img/9.6fb8563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/9.png
// module id = 19xh
// module chunks = 0